import React from 'react'

import { Box, Color } from '@gousto-internal/citrus-react'

type AccordionTableRowContainerProps = {
  children: React.ReactNode
  bgColor: Color
}

export const AccordionTableRowContainer = ({
  children,
  bgColor,
}: AccordionTableRowContainerProps) => (
  <Box
    bg={bgColor}
    paddingV={2}
    minHeight="60px"
    paddingH={3}
    color={Color.NeutralGrey_900}
    role="row"
  >
    {children}
  </Box>
)
